function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './NoFamilyMembers.pcss';
var _React_PureComponent;
class NoFamilyMembers extends (_React_PureComponent = React.PureComponent) {
    get approvedFamilyLinkInvitations() {
        return this.props.familyLinkInvitations.filter((fl)=>fl.status === 'Approved');
    }
    render() {
        const { familyLinkRequests } = this.props;
        const { approvedFamilyLinkInvitations } = this;
        if (approvedFamilyLinkInvitations.length || familyLinkRequests.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "w-100",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/assets/svg/no-people.svg",
                        className: styles.icon,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noFamilyMembers))
                })
            ]
        });
    }
}
_define_property(NoFamilyMembers, "propTypes", {
    // Implicit props
    familyLinkInvitations: PropTypes.array,
    familyLinkRequests: PropTypes.array,
    isInProgress: PropTypes.bool
});
const mapStateToProps = (state)=>({
        familyLinkInvitations: selectors.familyLinkInvitations(state),
        familyLinkRequests: selectors.familyLinkRequests(state),
        isInProgress: selectors.isFetchFamilyLinksInProgress(state)
    });
const ConnectedNoFamilyMembers = connect(mapStateToProps)(NoFamilyMembers);
export default withStyles(styles)(ConnectedNoFamilyMembers);
